<template>
  <div>
    <a-modal
      :title="ModalTitle"
      :visible="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
    >
      <a-form
        layout="horizontal"
        :form="form"
      >
        <a-form-item
          label="原密码"
          :labelCol="{span:4}"
          :wrapperCol="{span:18}"
        >
          <a-input
            placeholder="请输入原密码"
            type="password"
            v-decorator="[
                    'oldPwd',
                    {rules: [{ required: true, message: '原密码不能为空!' }]}
                ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="新密码"
          :labelCol="{span:4}"
          :wrapperCol="{span:18}"
        >
          <a-input
            placeholder="请输入新密码"
            type="password"
            v-decorator="[
                    'newPwd',
                    {rules: [{ required: true, message: '新密码不能为空!' }]}
                ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="确认密码"
          :labelCol="{span:4}"
          :wrapperCol="{span:18}"
        >
          <a-input
            placeholder="请再次输入新密码"
            type="password"
            v-decorator="[
                    'confirmNewPwd',
                    {rules: [{ required: true, message: '确认密码不能为空!' },{validator:validatorPassword}]}
                ]"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ModalTitle: '修改密码'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleOk (e) {
      this.$emit('submit', this.form)
    },
    handleCancel (e) {
      this.form.setFieldsValue({
        oldPwd: '',
        newPwd: '',
        confirmNewPwd: ''
      })

      this.$emit('cancel')
    },
    validatorPassword (rule, value, callback) {
      if (value && value !== this.form.getFieldValue('newPwd')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('两次输入不一致！')
      }
      callback()
    }

  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>
